var map = {
	"./arrow-next.svg": "ofRK",
	"./arrow-prev.svg": "UgiJ",
	"./arrow-small-next.svg": "gR6t",
	"./chevron-down.svg": "iZlM",
	"./clock.svg": "JXWf",
	"./cross.svg": "iav2",
	"./download.svg": "FJku",
	"./facebook.svg": "p85P",
	"./flag-fr.svg": "Sp2f",
	"./flag-uk.svg": "v+qQ",
	"./home.svg": "A5yt",
	"./link-external.svg": "lfok",
	"./mail.svg": "7oUM",
	"./menu.svg": "JL87",
	"./phone.svg": "7ROy",
	"./poi.svg": "ACxN"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Pvfh";